/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Para actualizar el estado de carga y de error en `}<inlineCode parentName="p">{`<Pokedex />`}</inlineCode>{` utilizando Svelte, basta con mandarle los estados a  `}<inlineCode parentName="p">{`<PokedexForm />`}</inlineCode>{` con el prefijo `}<inlineCode parentName="p">{`bind:`}</inlineCode>{` para que queden enlazados los valores y después podremos cambiar los valores de manera normal.`}</p>
    <p>{`También le pasaremos `}<inlineCode parentName="p">{`pokemonId`}</inlineCode>{` para actualizar el ID del Pokémon que estamos buscando con los datos del formulario.`}</p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-html"
      }}><code parentName="pre" {...{
          "className": "language-html"
        }}>{`// ...Pokedex.svelte
`}<span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`PokemonForm`}</span>{`
  `}<span parentName="span" {...{
              "className": "token attr-name"
            }}><span parentName="span" {...{
                "className": "token namespace"
              }}>{`bind:`}</span>{`pokemonId`}</span><span parentName="span" {...{
              "className": "token attr-value"
            }}><span parentName="span" {...{
                "className": "token punctuation attr-equals"
              }}>{`=`}</span>{`{pokemonId}`}</span>{`
  `}<span parentName="span" {...{
              "className": "token attr-name"
            }}><span parentName="span" {...{
                "className": "token namespace"
              }}>{`bind:`}</span>{`loading`}</span><span parentName="span" {...{
              "className": "token attr-value"
            }}><span parentName="span" {...{
                "className": "token punctuation attr-equals"
              }}>{`=`}</span>{`{loading}`}</span>{`
  `}<span parentName="span" {...{
              "className": "token attr-name"
            }}><span parentName="span" {...{
                "className": "token namespace"
              }}>{`bind:`}</span>{`error`}</span><span parentName="span" {...{
              "className": "token attr-value"
            }}><span parentName="span" {...{
                "className": "token punctuation attr-equals"
              }}>{`=`}</span>{`{error}`}</span>{`
`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`/>`}</span></span>{`


// Dentro de PokedexForm.svelte
`}<span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`script`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token script"
          }}><span parentName="span" {...{
              "className": "token language-javascript"
            }}>{`
  `}<span parentName="span" {...{
                "className": "token keyword"
              }}>{`let`}</span>{` pokemonName
  `}<span parentName="span" {...{
                "className": "token comment"
              }}>{`// Recibimos los valores de nuestro estado`}</span>{`
  `}<span parentName="span" {...{
                "className": "token keyword module"
              }}>{`export`}</span>{` `}<span parentName="span" {...{
                "className": "token keyword"
              }}>{`let`}</span>{` pokemonId
  `}<span parentName="span" {...{
                "className": "token keyword module"
              }}>{`export`}</span>{` `}<span parentName="span" {...{
                "className": "token keyword"
              }}>{`let`}</span>{` loading
  `}<span parentName="span" {...{
                "className": "token keyword module"
              }}>{`export`}</span>{` `}<span parentName="span" {...{
                "className": "token keyword"
              }}>{`let`}</span>{` error

  `}<span parentName="span" {...{
                "className": "token keyword"
              }}>{`const`}</span>{` `}<span parentName="span" {...{
                "className": "token function-variable function"
              }}>{`handleSubmit`}</span>{` `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`=`}</span>{` `}<span parentName="span" {...{
                "className": "token parameter"
              }}>{`e`}</span>{` `}<span parentName="span" {...{
                "className": "token arrow operator"
              }}>{`=>`}</span>{` `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`
    e`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "token method function property-access"
              }}>{`preventDefault`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`(`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`)`}</span>{`
    `}<span parentName="span" {...{
                "className": "token comment"
              }}>{`// Loading será true por que hará una petición a la API`}</span>{`
    `}<span parentName="span" {...{
                "className": "token keyword control-flow"
              }}>{`if`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`(`}</span>{`pokemonName `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`!==`}</span>{` `}<span parentName="span" {...{
                "className": "token string"
              }}>{`''`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`)`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`
      error `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`=`}</span>{` `}<span parentName="span" {...{
                "className": "token boolean"
              }}>{`false`}</span>{`
      loading `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`=`}</span>{` `}<span parentName="span" {...{
                "className": "token boolean"
              }}>{`true`}</span>{`
      `}<span parentName="span" {...{
                "className": "token keyword"
              }}>{`const`}</span>{` newPokemonId `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`=`}</span>{` `}<span parentName="span" {...{
                "className": "token dom variable"
              }}>{`window`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "token method function property-access"
              }}>{`isNaN`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`(`}</span><span parentName="span" {...{
                "className": "token function"
              }}>{`parseInt`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`(`}</span>{`pokemonName`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`)`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`)`}</span>{` `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`?`}</span>{` pokemonName`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "token method function property-access"
              }}>{`toLowerCase`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`(`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`)`}</span>{` `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`:`}</span>{` pokemonName
      pokemonId `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`=`}</span>{` newPokemonId
      pokemonName `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`=`}</span>{` `}<span parentName="span" {...{
                "className": "token string"
              }}>{`''`}</span>{` `}<span parentName="span" {...{
                "className": "token comment"
              }}>{`// Reiniciamos el formulario`}</span>{`
      `}<span parentName="span" {...{
                "className": "token keyword control-flow"
              }}>{`return`}</span>{`
    `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span>{`
    error `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`=`}</span>{` `}<span parentName="span" {...{
                "className": "token boolean"
              }}>{`true`}</span>{` `}<span parentName="span" {...{
                "className": "token comment"
              }}>{`// Si mandas el formulario vacío, hay un error`}</span>{`
  `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span>{`
`}</span></span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`script`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span>{`

`}<span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`form`}</span>{` `}<span parentName="span" {...{
              "className": "token attr-name"
            }}>{`class`}</span><span parentName="span" {...{
              "className": "token attr-value"
            }}><span parentName="span" {...{
                "className": "token punctuation attr-equals"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span>{`pokemon-form`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span></span>{` `}<span parentName="span" {...{
              "className": "token attr-name"
            }}><span parentName="span" {...{
                "className": "token namespace"
              }}>{`on:`}</span>{`submit`}</span><span parentName="span" {...{
              "className": "token attr-value"
            }}><span parentName="span" {...{
                "className": "token punctuation attr-equals"
              }}>{`=`}</span>{`{handleSubmit}`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span>{`
`}</code></pre></div>
    <p>{`Lo siguiente que queremos hacer, es que si cambia el valor de `}<inlineCode parentName="p">{`pokemonID`}</inlineCode>{`, se debe de ejecutar otra vez la función `}<inlineCode parentName="p">{`getPokemon()`}</inlineCode>{` encargada de buscar nuestro Pokémon en la API. Para lograrlo, solo necesitamos agregar un par de líneas de código.`}</p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-jsx"
      }}><code parentName="pre" {...{
          "className": "language-jsx"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`//Si cambia, entonces..`}</span>{`
`}<span parentName="code" {...{
            "className": "token literal-property property"
          }}>{`$`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword control-flow"
          }}>{`if`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`pokemonId`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token function"
          }}>{`getPokemon`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}</code></pre></div>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;